import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, ApiError } from "../api";
import { Loading, ErrorNote } from "../components/ui";
import { PeriodFilters } from "../components/PeriodFilters";
import { useLocations } from "../hooks";
import type { Filters, RankingRow, Rankings as RankingsData } from "../types";

function RankTable({ title, rows }: { title: string; rows: RankingRow[] }) {
  return (
    <div className="panel">
      <h2>{title}</h2>
      <table>
        <thead>
          <tr><th>#</th><th>Employee</th><th>ID</th><th>Dept</th><th>Days</th>
            <th>Total inside</th><th>Incomplete</th></tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.employee_id}>
              <td>{i + 1}</td>
              <td><Link to={`/employees/${encodeURIComponent(r.employee_id)}`}>{r.employee_name || "—"}</Link></td>
              <td><Link to={`/employees/${encodeURIComponent(r.employee_id)}`}>{r.employee_id}</Link></td>
              <td>{r.department}</td>
              <td>{r.present_days}</td>
              <td>{r.total_inside_hhmm}</td>
              <td>{r.incomplete_days || ""}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={7} className="notice">No data.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}

export default function Rankings() {
  const locations = useLocations();
  const [filters, setFilters] = useState<Filters>({});
  const [data, setData] = useState<RankingsData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.rankings(filters)
      .then((d) => { setData(d); setError(null); })
      .catch((e: ApiError) => setError(e.message))
      .finally(() => setLoading(false));
  }, [filters]);

  return (
    <div>
      <h1 className="h1">Rankings</h1>
      <p className="sub">Ranked by distinct valid presence days, then total inside time.</p>
      <PeriodFilters locations={locations} initialMode="month" storageKey="rankings" onChange={setFilters} />
      {loading && <Loading what="rankings" />}
      {error && <ErrorNote message={error} />}
      {data && !loading && (
        <>
          <RankTable title="Top 10 most present" rows={data.top_present} />
          <RankTable title="Top 10 least present (eligible)" rows={data.least_present} />
        </>
      )}
    </div>
  );
}
